import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { ProductApiService } from 'src/app/services/api/product-api.service';
import { PlatformDialogTestComponent } from '../platform-dialog-test/platform-dialog-test.component';

@Component({
  selector: 'app-platform-selection-modal',
  templateUrl: './platform-selection-modal.component.html',
  styleUrls: ['./platform-selection-modal.component.scss'],
})
export class PlatformSelectionModalComponent {
  list = [
    { item1: '支持设备：', item2: '电脑', item3: '所有', item4: '所有' },
    { item1: '清退概率：', item2: '无', item3: '小', item4: '高' },
    {
      item1: '价格差异：',
      item2: '',
      item3: '99.99/年',
      item4: '',
    },
    {
      item1: '使用限制：',
      item2: '同时3设备',
      item3: '同时1设备',
      item4: '同时1设备',
    },
    { item1: '观影记录：', item2: '无', item3: '有效期内', item4: '有' },
    {
      item1: '服务体验：',
      item2: '官方原版',
      item3: '官方原版',
      item4: '官方原版',
    },
  ];

  constructor(
    private dialogRef: MatDialogRef<PlatformSelectionModalComponent>,
    private dialog: MatDialog,
    private api: ProductApiService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data.id === 2) {
      this.list[2].item2 = '94.22/年';
      this.list[2].item4 = '398.88/年';
    } else if (this.data.id === 6) {
      this.list[2].item2 = '79.44/年';
      this.list[2].item4 = '178.88/年';
    } else if (this.data.id === 11) {
      this.list[2].item2 = '44.94/年';
      this.list[2].item4 = '217.76/年';
    } else if (this.data.id === 5) {
      this.list[2].item2 = '63.44/年';
      this.list[2].item4 = '178.88/年';
    } else if (this.data.id === 57) {
      this.list[2].item2 = '49.94/年';
      this.list[2].item4 = '188.88/年';
    }
  }

  close(r: any = null) {
    this.dialogRef.close(r);
  }

  buy(name: number) {
    if (name === 3) {
      this.close(true);
      return;
    }

    if (name === 1) this.getPlatformInfo(67); // 爆米花
    else if (name === 2) this.getPlatformInfo(84); // 借个号
  }

  loading = false;
  platform: any;
  async getPlatformInfo(id: number) {
    try {
      this.loading = true;
      const r = await this.api.getPlatform(id);
      this.platform = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
      this.close();
      this.dialog.open(PlatformDialogTestComponent, {
        data: Object.assign({}, this.platform),
        autoFocus: false,
        panelClass: 'app-dialog',
      });
    }
  }
}
